export const UPDATE_OFFERING_FORM = 'UPDATE_OFFERING_FORM';
export const UPDATE_OFFERING_TABLE = 'UPDATE_OFFERING_TABLE';
export const RESET_STATE = 'RESET_STATE';


